import { SxProps, Theme } from '@mui/material/styles';

const style: SxProps<Theme> = [
  {
    '& .label': {
      position: 'inherit',
      transform: 'none !important',
      marginBottom: '8px',
      fontSize: 14,
    },
    '& .MuiInputBase-root': {
      minWidth: 340,
    },
    '& legend': {
      display: 'none',
    },
    '& .textField': {
      marginBottom: 0,

      '& fieldset': {
        top: '0 !important',
      },
      '& input, & textarea': {
        minWidth: 340,
      },
    },
  },
];

export default style;
